/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddQuizPlanDayCommandResult } from '../model/addQuizPlanDayCommandResult';
import { AssignQuizPlanCommand } from '../model/assignQuizPlanCommand';
import { AssignQuizPlanCommandResult } from '../model/assignQuizPlanCommandResult';
import { CreateQuizPlanCommand } from '../model/createQuizPlanCommand';
import { CreateQuizPlanCommandResult } from '../model/createQuizPlanCommandResult';
import { CreateQuizPlanItemCommand } from '../model/createQuizPlanItemCommand';
import { CreateQuizPlanItemCommandResult } from '../model/createQuizPlanItemCommandResult';
import { DeleteQuizPlanCommand } from '../model/deleteQuizPlanCommand';
import { DeleteQuizPlanCommandResult } from '../model/deleteQuizPlanCommandResult';
import { DeleteQuizPlanDayCommandResult } from '../model/deleteQuizPlanDayCommandResult';
import { DeleteQuizPlanItemCommandResult } from '../model/deleteQuizPlanItemCommandResult';
import { GetQuizPlansQueryResult } from '../model/getQuizPlansQueryResult';
import { GetSingleQuizPlanQueryResult } from '../model/getSingleQuizPlanQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { RemoveQuizPlanImageCommandResult } from '../model/removeQuizPlanImageCommandResult';
import { ResourceScopeType } from '../model/resourceScopeType';
import { UpdateQuizPlanCommand } from '../model/updateQuizPlanCommand';
import { UpdateQuizPlanItemCommand } from '../model/updateQuizPlanItemCommand';
import { UpdateQuizPlanVisibilityCommand } from '../model/updateQuizPlanVisibilityCommand';
import { UploadQuizPlanImageCommandResult } from '../model/uploadQuizPlanImageCommandResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class QuizPlanService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanAssignPost(body?: AssignQuizPlanCommand, observe?: 'body', reportProgress?: boolean): Observable<AssignQuizPlanCommandResult>;
    public quizPlanAssignPost(body?: AssignQuizPlanCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AssignQuizPlanCommandResult>>;
    public quizPlanAssignPost(body?: AssignQuizPlanCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AssignQuizPlanCommandResult>>;
    public quizPlanAssignPost(body?: AssignQuizPlanCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AssignQuizPlanCommandResult>('post',`${this.basePath}/QuizPlan/assign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanDelete(body?: DeleteQuizPlanCommand, observe?: 'body', reportProgress?: boolean): Observable<DeleteQuizPlanCommandResult>;
    public quizPlanDelete(body?: DeleteQuizPlanCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteQuizPlanCommandResult>>;
    public quizPlanDelete(body?: DeleteQuizPlanCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteQuizPlanCommandResult>>;
    public quizPlanDelete(body?: DeleteQuizPlanCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DeleteQuizPlanCommandResult>('delete',`${this.basePath}/QuizPlan`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param filterLength 
     * @param filterCreatedByUserUids 
     * @param filterTeamUid 
     * @param filterLevel 
     * @param filterInQuizPlanLibrary 
     * @param filterCategoryUid 
     * @param bundleUid 
     * @param selectedDateLocal 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanGet(filterLength?: number, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterLevel?: ResourceScopeType, filterInQuizPlanLibrary?: boolean, filterCategoryUid?: string, bundleUid?: string, selectedDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetQuizPlansQueryResult>;
    public quizPlanGet(filterLength?: number, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterLevel?: ResourceScopeType, filterInQuizPlanLibrary?: boolean, filterCategoryUid?: string, bundleUid?: string, selectedDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetQuizPlansQueryResult>>;
    public quizPlanGet(filterLength?: number, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterLevel?: ResourceScopeType, filterInQuizPlanLibrary?: boolean, filterCategoryUid?: string, bundleUid?: string, selectedDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetQuizPlansQueryResult>>;
    public quizPlanGet(filterLength?: number, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterLevel?: ResourceScopeType, filterInQuizPlanLibrary?: boolean, filterCategoryUid?: string, bundleUid?: string, selectedDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterLength !== undefined && filterLength !== null) {
            queryParameters = queryParameters.set('Filter.Length', <any>filterLength);
        }
        if (filterCreatedByUserUids) {
            filterCreatedByUserUids.forEach((element) => {
                queryParameters = queryParameters.append('Filter.CreatedByUserUids', <any>element);
            })
        }
        if (filterTeamUid !== undefined && filterTeamUid !== null) {
            queryParameters = queryParameters.set('Filter.TeamUid', <any>filterTeamUid);
        }
        if (filterLevel !== undefined && filterLevel !== null) {
            queryParameters = queryParameters.set('Filter.Level', <any>filterLevel);
        }
        if (filterInQuizPlanLibrary !== undefined && filterInQuizPlanLibrary !== null) {
            queryParameters = queryParameters.set('Filter.InQuizPlanLibrary', <any>filterInQuizPlanLibrary);
        }
        if (filterCategoryUid !== undefined && filterCategoryUid !== null) {
            queryParameters = queryParameters.set('Filter.CategoryUid', <any>filterCategoryUid);
        }
        if (bundleUid !== undefined && bundleUid !== null) {
            queryParameters = queryParameters.set('BundleUid', <any>bundleUid);
        }
        if (selectedDateLocal !== undefined && selectedDateLocal !== null) {
            queryParameters = queryParameters.set('SelectedDateLocal', <any>selectedDateLocal);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetQuizPlansQueryResult>('get',`${this.basePath}/QuizPlan`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanItemPost(body?: CreateQuizPlanItemCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateQuizPlanItemCommandResult>;
    public quizPlanItemPost(body?: CreateQuizPlanItemCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateQuizPlanItemCommandResult>>;
    public quizPlanItemPost(body?: CreateQuizPlanItemCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateQuizPlanItemCommandResult>>;
    public quizPlanItemPost(body?: CreateQuizPlanItemCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateQuizPlanItemCommandResult>('post',`${this.basePath}/QuizPlan/item`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanItemUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteQuizPlanItemCommandResult>;
    public quizPlanItemUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteQuizPlanItemCommandResult>>;
    public quizPlanItemUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteQuizPlanItemCommandResult>>;
    public quizPlanItemUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanItemUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteQuizPlanItemCommandResult>('delete',`${this.basePath}/QuizPlan/item/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanItemUidPut(uid: string, body?: UpdateQuizPlanItemCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public quizPlanItemUidPut(uid: string, body?: UpdateQuizPlanItemCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public quizPlanItemUidPut(uid: string, body?: UpdateQuizPlanItemCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public quizPlanItemUidPut(uid: string, body?: UpdateQuizPlanItemCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanItemUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/QuizPlan/item/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Updates whether quiz plans are shared to the library
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanPatch(body?: UpdateQuizPlanVisibilityCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public quizPlanPatch(body?: UpdateQuizPlanVisibilityCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public quizPlanPatch(body?: UpdateQuizPlanVisibilityCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public quizPlanPatch(body?: UpdateQuizPlanVisibilityCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('patch',`${this.basePath}/QuizPlan`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanPost(body?: CreateQuizPlanCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateQuizPlanCommandResult>;
    public quizPlanPost(body?: CreateQuizPlanCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateQuizPlanCommandResult>>;
    public quizPlanPost(body?: CreateQuizPlanCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateQuizPlanCommandResult>>;
    public quizPlanPost(body?: CreateQuizPlanCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateQuizPlanCommandResult>('post',`${this.basePath}/QuizPlan`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param dayNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanUidDayDayNumberDelete(uid: string, dayNumber: number, observe?: 'body', reportProgress?: boolean): Observable<DeleteQuizPlanDayCommandResult>;
    public quizPlanUidDayDayNumberDelete(uid: string, dayNumber: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteQuizPlanDayCommandResult>>;
    public quizPlanUidDayDayNumberDelete(uid: string, dayNumber: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteQuizPlanDayCommandResult>>;
    public quizPlanUidDayDayNumberDelete(uid: string, dayNumber: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanUidDayDayNumberDelete.');
        }

        if (dayNumber === null || dayNumber === undefined) {
            throw new Error('Required parameter dayNumber was null or undefined when calling quizPlanUidDayDayNumberDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteQuizPlanDayCommandResult>('delete',`${this.basePath}/QuizPlan/${encodeURIComponent(String(uid))}/day/${encodeURIComponent(String(dayNumber))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanUidDayPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<AddQuizPlanDayCommandResult>;
    public quizPlanUidDayPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddQuizPlanDayCommandResult>>;
    public quizPlanUidDayPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddQuizPlanDayCommandResult>>;
    public quizPlanUidDayPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanUidDayPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddQuizPlanDayCommandResult>('post',`${this.basePath}/QuizPlan/${encodeURIComponent(String(uid))}/day`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param isPreview 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanUidGet(uid: string, isPreview?: boolean, observe?: 'body', reportProgress?: boolean): Observable<GetSingleQuizPlanQueryResult>;
    public quizPlanUidGet(uid: string, isPreview?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSingleQuizPlanQueryResult>>;
    public quizPlanUidGet(uid: string, isPreview?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSingleQuizPlanQueryResult>>;
    public quizPlanUidGet(uid: string, isPreview?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanUidGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isPreview !== undefined && isPreview !== null) {
            queryParameters = queryParameters.set('isPreview', <any>isPreview);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSingleQuizPlanQueryResult>('get',`${this.basePath}/QuizPlan/${encodeURIComponent(String(uid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Removes the background image from a quiz plan template
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanUidImageDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveQuizPlanImageCommandResult>;
    public quizPlanUidImageDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveQuizPlanImageCommandResult>>;
    public quizPlanUidImageDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveQuizPlanImageCommandResult>>;
    public quizPlanUidImageDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanUidImageDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RemoveQuizPlanImageCommandResult>('delete',`${this.basePath}/QuizPlan/${encodeURIComponent(String(uid))}/image`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Uploads a background image for a quiz plan template
     * 
     * @param uid 
     * @param image 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanUidImagePostForm(uid: string, image?: Blob, observe?: 'body', reportProgress?: boolean): Observable<UploadQuizPlanImageCommandResult>;
    public quizPlanUidImagePostForm(uid: string, image?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadQuizPlanImageCommandResult>>;
    public quizPlanUidImagePostForm(uid: string, image?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadQuizPlanImageCommandResult>>;
    public quizPlanUidImagePostForm(uid: string, image?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanUidImagePost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (image !== undefined) {
            formParams = formParams.append('image', <any>image) as any || formParams;
        }

        return this.httpClient.request<UploadQuizPlanImageCommandResult>('post',`${this.basePath}/QuizPlan/${encodeURIComponent(String(uid))}/image`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizPlanUidPut(uid: string, body?: UpdateQuizPlanCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public quizPlanUidPut(uid: string, body?: UpdateQuizPlanCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public quizPlanUidPut(uid: string, body?: UpdateQuizPlanCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public quizPlanUidPut(uid: string, body?: UpdateQuizPlanCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizPlanUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/QuizPlan/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
